import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import store from './data/store';
import TopMenuMobile from './ui/main';

export const initTopMobile = () => {
    const $rootMobile = document.getElementById('top-menu-m-placeholder');
    if (!$rootMobile) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <TopMenuMobile />
            </Provider>
        </React.StrictMode>,
        $rootMobile
    );

    const $rootTablet = document.getElementById('top-menu-t-placeholder');
    if (!$rootTablet) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <TopMenuMobile />
            </Provider>
        </React.StrictMode>,
        $rootTablet
    );
};
